import { IconType } from "@twinkltech/curriculum-architect-component-library";

import { getDefaultSubjectIcon } from "@/utils/SubjectHelper/utils/getDefaultSubjectIcon/getDefaultSubjectIcon";
import { getSubjectDisplayLabel } from "@/utils/SubjectHelper/utils/getSubjectDisplayLabel/getSubjectDisplayLabel";

import type { Subject } from "@twinkltech/curriculum-architect-domain-hooks";

export type SubjectWithUiData = Subject & {
  icon: IconType;
  label: string;
};

// The Icon Type is currently the only reason this can't really be moved to the domain-hooks package...
export const mapSubjectUiData = (subject: Subject): SubjectWithUiData => {
  return {
    ...subject,
    label: getSubjectDisplayLabel(subject),
    icon: getDefaultSubjectIcon({ slug: subject.slug }),
  };
};
